import { Stack, Switch, Typography } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { isShowSerieLabel } from "../../../../viewer/chart/style/serie/isShowSerieLabel.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  serie: SeriesSettings;
  readonlyMode: boolean;
}

export default function ShowLabelItem({ settings, serie, readonlyMode }: Props) {
  const showLabel = React.useMemo(() => isShowSerieLabel(serie.name, settings), [settings, serie]);
  const dispatch = useAppDispatch();
  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Show Labels</Typography>
      <HorizontalFill />
      <Switch
        checked={showLabel}
        disabled={readonlyMode}
        onChange={(_, value) =>
          dispatch(fieldsStateActions.updateSeriesSettings({ name: serie.name, changes: { showLabel: value } }))
        }
      />
    </Stack>
  );
}
